var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form",
    _vm._b(
      {
        ref: "formRef",
        staticClass: "schema-search-form",
        attrs: { model: _vm.query },
      },
      "el-form",
      _vm.formPropsC,
      false
    ),
    [
      _c(
        "el-row",
        {
          staticClass: "schema-search-row",
          attrs: {
            gutter: _vm.gutter,
            type: "flex",
            justify: "start",
            align: "middle",
          },
        },
        [
          _vm._l(_vm.visibleFields, function (field, idx) {
            return _c(
              "el-col",
              {
                key: _vm.fieldKey(field, idx),
                attrs: {
                  span: _vm.resolveSpanByContainer(field),
                  offset: field.component === "actions" ? _vm.actionOffset : 0,
                },
              },
              [
                field.component === "actions"
                  ? _c(
                      "div",
                      {
                        tag: "component",
                        staticClass: "schema-search-actions",
                        class: {
                          "schema-search-actions--expanded": _vm.expanded,
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("search")
                              },
                            },
                          },
                          [_vm._v("筛选")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("reset")
                              },
                            },
                          },
                          [_vm._v("重置")]
                        ),
                        _vm.hasAdvanced
                          ? _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit(
                                      "update:expanded",
                                      !_vm.expanded
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.expanded ? "收起" : "更多条件") +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  {
                    staticClass: "schema-search-item",
                    attrs: { label: field.label },
                  },
                  [
                    field.component === "input"
                      ? _c(
                          "el-input",
                          _vm._b(
                            {
                              staticClass: "schema-search-input",
                              attrs: {
                                placeholder:
                                  field.componentProps?.placeholder ||
                                  "输入" + field?.label,
                              },
                              model: {
                                value: _vm.query[field.prop],
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, field.prop, $$v)
                                },
                                expression: "query[field.prop]",
                              },
                            },
                            "el-input",
                            field.componentProps,
                            false
                          )
                        )
                      : field.component === "number"
                      ? _c(
                          "el-input-number",
                          _vm._b(
                            {
                              staticClass: "schema-search-input",
                              attrs: {
                                placeholder:
                                  field.componentProps?.placeholder ||
                                  "输入" + field?.label,
                              },
                              model: {
                                value: _vm.query[field.prop],
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, field.prop, $$v)
                                },
                                expression: "query[field.prop]",
                              },
                            },
                            "el-input-number",
                            field.componentProps,
                            false
                          )
                        )
                      : field.component === "select"
                      ? _c(
                          "el-select",
                          _vm._b(
                            {
                              staticClass: "schema-search-input",
                              attrs: {
                                placeholder:
                                  field.componentProps?.placeholder ||
                                  "选择" + field?.label,
                              },
                              model: {
                                value: _vm.query[field.prop],
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, field.prop, $$v)
                                },
                                expression: "query[field.prop]",
                              },
                            },
                            "el-select",
                            field.componentProps,
                            false
                          ),
                          _vm._l(field.options || [], function (opt, oIdx) {
                            return _c("el-option", {
                              key: opt.key + "_" + oIdx,
                              attrs: { label: opt.label, value: opt.value },
                            })
                          }),
                          1
                        )
                      : field.component === "datetime-range"
                      ? _c(
                          "DateTimeRangePicker",
                          _vm._b(
                            {
                              staticClass: "schema-search-input",
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.query[field.prop],
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, field.prop, $$v)
                                },
                                expression: "query[field.prop]",
                              },
                            },
                            "DateTimeRangePicker",
                            field.componentProps,
                            false
                          )
                        )
                      : field.component === "date-range"
                      ? _c(
                          "el-date-picker",
                          _vm._b(
                            {
                              staticClass: "schema-search-input",
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "daterange",
                                "range-separator": "至",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期",
                                "value-format": "yyyy-MM-dd",
                              },
                              model: {
                                value: _vm.query[field.prop],
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, field.prop, $$v)
                                },
                                expression: "query[field.prop]",
                              },
                            },
                            "el-date-picker",
                            field.componentProps,
                            false
                          )
                        )
                      : field.component === "prepend-input"
                      ? _c(
                          "PrependInput",
                          _vm._b(
                            {
                              staticClass: "schema-search-input",
                              attrs: { options: field.options },
                              model: {
                                value: _vm.query[field.prop],
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, field.prop, $$v)
                                },
                                expression: "query[field.prop]",
                              },
                            },
                            "PrependInput",
                            field.componentProps,
                            false
                          )
                        )
                      : _vm._t(field.slot || field.prop, null, {
                          query: _vm.query,
                          field: field,
                        }),
                  ],
                  2
                ),
              ],
              1
            )
          }),
          _vm._t("extra", null, { query: _vm.query }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }